<form [formGroup]="caseManagerForm" class="k-form">
  <div class="pl-3 pr-3 pb-3">
    <label class="k-form-field">
      <span class="k-text-uppercase dark">
        {{'ASSIGNEE' | translate}} *
      </span>
      <kendo-combobox class="w-100" formControlName="assignee" required [data]="channelStaffFiltered"
        [textField]="'name'" [valueField]="'id'" [filterable]="true" (filterChange)="caseManagerFilter($event)"
        (close)="searchTerm=''" [itemDisabled]="itemDisabled" [placeholder]="'TYPE-OR-SELECT' | translate">
        <ng-template kendoComboBoxItemTemplate let-dataItem>
          <span innerHTML="{{ dataItem.name | highlight : searchTerm }}">
          </span>
        </ng-template>
      </kendo-combobox>
    </label>
    <label class="k-form-field">
      <span class="k-text-uppercase dark">
        {{'REASON-FOR-REASSIGN' | translate}} *
      </span>
      <textarea kendoTextArea [autoSize]="true" class="w-100 k-textarea" rows="2" formControlName="reasonForReassign"
        maxlength="512">
      </textarea>
    </label>
    <!--Reassigned Open Tasks-->
    <div class="k-form-field">
      <input type="checkbox" id="reassignOpenTasks" formControlName="reassignOpenTasks" kendoCheckBox />
      <label class="k-checkbox-label k-text-uppercase dark" for="reassignOpenTasks">{{
        'REASSIGN-OPEN-TASKS' | translate }}
      </label>
    </div>
  </div>
</form>
<div>* {{'REQUIRED-FIELDS' | translate}}</div>